import { Container, Tag } from "@fluidattacks/design";

const tagsFormatter = (tags: string): JSX.Element => (
  <Container
    display={"flex"}
    gap={0.25}
    py={0.25}
    style={{ flexWrap: "wrap" }}
    width={"100%"}
  >
    {tags.split(",").map(
      (tag): JSX.Element => (
        <Tag key={tag} tagLabel={tag} />
      ),
    )}
  </Container>
);
export { tagsFormatter };
